const paginas = [
  {
    pagina: 1,
    id: '1',
    nombre: 'LOGIN',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'gptw',
        nombre: 'LOGO',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'logo',
            tipo: 'imagen',
            descripcion: 'Puede cambiar la imagen que aparece en el login alv'
          },
          // {
          //   id: 'name',
          //   tipo: 'texto',
          //   descripcion: 'Puede escribir el nombre del broker'
          // }
        ]
      },
      {
        id: 'screen_customContent',
        nombre: 'INSTRUCCIONES',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Puede cambiar las instrucciones a mostrar antes de entrar a la encuesta'
          }
        ]
      },
      {
        id: 'screen_customContent',
        nombre: 'LOGINFORM',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          // {
          //   id: 'inputPlaceHolderUser',
          //   tipo: 'texto',
          //   descripcion: 'Puede escribir el texto de sugerencia para el campo de "usuario"'
          // },
          {
            id: 'inputPlaceHolderPass',
            tipo: 'texto',
            descripcion: 'Puede escribir el texto de sugerencia para el campo de "contraseña"'
          },
          {
            id: 'buttons_login_label',
            tipo: 'texto',
            descripcion: 'Puede escribir el texto del botón de inicio de sesión'
          },
          {
            id: 'recoveryAccessKey_text',
            tipo: 'texto',
            descripcion: 'Puede escribir el texto del botón para recuperar la contraseña'
          },
        ]
      },
      // {
      //   id: 'generics',
      //   nombre: 'BACKGROUND',
      //   imagenAyuda: 'imagen',
      //   status: 0,
      //   elementos: [
      //     {
      //       id: 'backgroudImage',
      //       tipo: 'imagen',
      //       descripcion: 'Puede cambiar la imagen de fondo que aparece en la encuesta'
      //     },
      //   ]
      // },
    ]
  },
  {
    pagina: 2,
    id: '2',
    nombre: 'GENERICOS',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'gptw',
        nombre: 'LOGO',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'logo',
            tipo: 'imagen',
            descripcion: 'Puede cambiar la imagen que aparece en el login alv'
          },
          // {
          //   id: 'name',
          //   tipo: 'texto',
          //   descripcion: 'Puede escribir el nombre del broker'
          // }
        ]
      },
      {
        id: 'generics',
        nombre: 'HEADER',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'buttons_logout_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cerrar sesión'
          },
          {
            id: 'header_logo',
            tipo: 'imagen',
            descripcion: 'Imagen del logo del sistema'
          },
          {
            id: 'isShowLastLogin_active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar la fecha del último acceso',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
          // {
          //   id: 'backgroundImage',
          //   tipo: 'imagen',
          //   descripcion: 'Imagen de fondo para la encuesta'
          // },
          {
            id: 'header_showUserName',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el nombre del usuario',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
        ]
      },
    ]
  },
  {
    pagina: 3,
    id: '3_screens_0',
    nombre: 'BIENVENIDA',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'customContent',
        nombre: 'CONTENIDO',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Puede modificar el contenido de la página de bienvenida'
          },
          {
            id: 'buttons_next_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para continuar'
          }
        ]
      },
      {
        id: 'windowLogout',
        nombre: 'LOGOUT',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal'
          },
          {
            id: 'buttons_cancel_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cancelar la acción'
          },
          {
            id: 'buttons_logout_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cerrar sesión'
          },
        ]
      },
    ]
  },
  {
    pagina: 4,
    id: '4',
    nombre: 'TERMINOS',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'generics_screenTerms',
        nombre: 'ACTIVAR',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el panel de instrucciones',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
        ]
      },
      {
        id: 'screens_4_customContent',
        nombre: 'CONTENIDO',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'header_title',
            tipo: 'editorHTML',
            descripcion: 'cabecera'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'texto del mensaje'
          },
          {
            id: 'buttons_previous_label',
            tipo: 'texto',
            descripcion: 'botón regresar'
          },
          {
            id: 'buttons_acept_label',
            tipo: 'texto',
            descripcion: 'botón acepto'
          },
          {
            id: 'buttons_cancel_label',
            tipo: 'texto',
            descripcion: 'botón cancelar'
          },
        ]
      },
      {
        id: 'screens_4_windowLogout',
        nombre: 'LOGOUT',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal'
          },
          {
            id: 'buttons_cancel_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cancelar la acción'
          },
          {
            id: 'buttons_logout_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cerrar sesión'
          },
        ]
      },
      {
        id: 'screens_4_windowNoAcept',
        nombre: 'NOACEPT',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal'
          },
          {
            id: 'buttons_saveAndExit_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para guardar y salir'
          },
        ]
      },
    ]
  },
  {
    pagina: 5,
    id: '5_screens_1',
    nombre: 'INSTRUCCIONES',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'customContent',
        nombre: 'CONTENIDO',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Puede modificar el contenido de la página de instrucciones'
          },
          {
            id: 'buttons_previous_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para regresar'
          },
          {
            id: 'buttons_start_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para ir al inicio'
          },
          {
            id: 'buttons_continue_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para continuar'
          },
        ]
      },
      {
        id: 'windowLogout',
        nombre: 'LOGOUT',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal'
          },
          {
            id: 'buttons_cancel_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cancelar la acción'
          },
          {
            id: 'buttons_logout_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cerrar sesión'
          },
        ]
      },
    ]
  },
  {
    pagina: 6,
    id: '6_screens_2',
    nombre: 'SURVEY',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'customContent_pagination',
        nombre: 'NAV',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'buttons_next_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para continuar a la siguiente página'
          },
          {
            id: 'buttons_previous_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para regresar a la página anterior'
          },
          {
            id: 'buttons_finish_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para finalizar la encuesta'
          },
        ]
      },
      {
        id: 'customContent_instructions',
        nombre: 'INSTRUCCIONES',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'button_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para mostrar el panel de instrucciones'
          },
          {
            id: 'active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el panel de instrucciones',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Puede modificar el contenido del panel de instrucciones'
          },
        ]
      },
      {
        id: 'customContent_definitions',
        nombre: 'SOPORTE',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'button_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para mostrar el panel de tips de soporte'
          },
          {
            id: 'active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el panel de tips de soporte',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Puede modificar el contenido del panel de tips de soporte'
          },
        ]
      },
      {
        id: 'customContent_reactive_organization',
        nombre: 'COLUMNA1',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Etiqueta de la perspectiva 1 de los reactivos'
          },
          {
            id: 'tooltip_active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el tooltip de la perspectiva',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
          {
            id: 'tooltip_text',
            tipo: 'editorHTML',
            descripcion: 'Puede modificar el texto del tooltip de la perspectiva'
          },
        ]
      },
      {
        id: 'customContent_reactive_workgroup',
        nombre: 'COLUMNA2',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Etiqueta de la perspectiva 2 de los reactivos'
          },
          {
            id: 'tooltip_active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el tooltip de la perspectiva 2',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
          {
            id: 'tooltip_text',
            tipo: 'editorHTML',
            descripcion: 'Puede modificar el texto del tooltip de la perspectiva 2'
          },
        ]
      },
      {
        id: 'customContent_windowFinish',
        nombre: 'FINISH_1',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'textAnswered',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal al responder todas las preguntas'
          },
          {
            id: 'textNotAnswered',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal al no responder todas las preguntas'
          },
          {
            id: 'textFooter',
            tipo: 'editorHTML',
            descripcion: 'Contenido del pie del mensaje modal'
          },
          {
            id: 'buttons_previous_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cancelar la acción'
          },
          {
            id: 'buttons_close_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para enviar las respuestas'
          },
        ]
      },
      {
        id: 'customContent',
        nombre: 'FINISH_2',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'windowFinishMessage_title',
            tipo: 'texto',
            descripcion: 'Titulo de la modal'
          },
          {
            id: 'windowFinishMessage_text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal tras finalizar la encuesta'
          },
          //ELEMENTOS DE RANKING
          {
            id: 'windowRanking_active',
            tipo: 'check',
            descripcion: 'Elegir entre mostrar u ocultar el mensaje para calificar la encuesta',
            textos: {
              on: 'Mostrar',
              off: 'Ocultar'
            }
          },
          {
            id: 'windowRanking_text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal para calificar la encuesta'
          },
          {
            id: 'windowFinishMessage_buttons_close_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para continuar'
          },
        ]
      },
      {
        id: 'windowLogout',
        nombre: 'LOGOUT_1',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal'
          },
          {
            id: 'textBandRequired',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal de advertencia de irreversibilidad'
          },
          {
            id: 'buttons_previous_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para cancelar la acción'
          },
          {
            id: 'buttons_saveAndExit_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para guardar cambios y cerrar sesión'
          },
        ]
      },
      {
        id: 'windowLogoutMessage',
        nombre: 'LOGOUT_2',
        imagenAyuda: 'imagen',
        status: 0,
        elementos: [
          {
            id: 'title',
            tipo: 'texto',
            descripcion: 'Titulo del mensaje modal'
          },
          {
            id: 'text',
            tipo: 'editorHTML',
            descripcion: 'Contenido del mensaje modal'
          },
          {
            id: 'buttons_close_label',
            tipo: 'texto',
            descripcion: 'Etiqueta del botón para continuar'
          },
        ]
      },
    ]
  },
];

export default paginas;
